import * as defaults from '../defaults';
import { getLineHeightInPx } from '../inject-missing-props-into-html';
import { toMobileFontSize } from '../font-utils/to-mobile-font-size';
import { getMobileLineHeightClassName } from './get-mobile-line-height-class-name';
import { extractValuesFromHtml } from './html';
const lineHeightExtractor = (css) => ($) => defaults.defaultContainerElements
    .map((e) => {
    return $(e)
        .map((_id, el) => getLineHeightInPx($(el), { css }))
        .get()
        .map(toMobileFontSize);
})
    .reduce((acc, curr) => acc.concat(curr), []);
export const getMobileLineHeightClasses = (htmls, { composerData }) => extractValuesFromHtml(htmls, lineHeightExtractor(composerData.styles.css))
    .map((lineHeight) => `.${getMobileLineHeightClassName(lineHeight)}{line-height: ${lineHeight}px !important;}`)
    .join(' ');
//# sourceMappingURL=get-mobile-line-height-classes.js.map